export interface ApiResponse<T> {
  txid: string
  status: number
  message: string
  data: T | null
  error?: ApiErrorDetail
}

export interface ApiErrorDetail {
  code: string
  description: string | null
}

export interface SpringPage<T> {
  content: T[]
  totalElements: number
  totalPages: number
  number: number
  size: number
}

export class ApiError extends Error {
  readonly code: string
  readonly description: string | null
  readonly status: number
  readonly txid: string

  constructor(code: string, description: string | null, status: number, txid: string) {
    super(description ?? code)
    this.name = 'ApiError'
    this.code = code
    this.description = description
    this.status = status
    this.txid = txid
  }
}
